import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
}

export function LanguageSwitcher({ className = '' }: Props) {
  const { i18n } = useTranslation();
  const current = i18n.language;

  return (
    <div className={`flex gap-px bg-white/[0.04] border border-[var(--grid-line)] rounded-lg p-0.5 ${className}`}>
      {(['zh', 'en'] as const).map((lang) => (
        <button
          key={lang}
          type="button"
          onClick={() => i18n.changeLanguage(lang)}
          className={`px-2.5 py-1 text-[11px] rounded-md cursor-pointer border-none transition-colors ${
            current.startsWith(lang)
              ? 'bg-daynote-accent text-[#2a2520] font-medium'
              : 'bg-transparent text-daynote-muted hover:text-daynote-text'
          }`}
        >
          {lang === 'zh' ? '中' : 'EN'}
        </button>
      ))}
    </div>
  );
}
